/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePaymentMethodData
 */
export interface UpdatePaymentMethodData {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentMethodData
     */
    isDefault?: boolean;
}

/**
 * Check if a given object implements the UpdatePaymentMethodData interface.
 */
export function instanceOfUpdatePaymentMethodData(value: object): value is UpdatePaymentMethodData {
    return true;
}

export function UpdatePaymentMethodDataFromJSON(json: any): UpdatePaymentMethodData {
    return UpdatePaymentMethodDataFromJSONTyped(json, false);
}

export function UpdatePaymentMethodDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePaymentMethodData {
    if (json == null) {
        return json;
    }
    return {
        
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
    };
}

  export function UpdatePaymentMethodDataToJSON(json: any): UpdatePaymentMethodData {
      return UpdatePaymentMethodDataToJSONTyped(json, false);
  }

  export function UpdatePaymentMethodDataToJSONTyped(value?: UpdatePaymentMethodData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isDefault': value['isDefault'],
    };
}

